










































































































import { Component, Mixins, Watch, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import { InquiryServiceDiv as InquiryServiceDivModel } from "@/model/inquiry";
import { VForm } from "@/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import AppIconButton from "@/components/admin_common/AppIconButton.vue";

@Component({
  components: {
    AppAuthButton,
    AppIconButton,
  },
})
export default class InquiryServiceDiv extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** Ref */
  @Ref("form") private readonly form!: VForm;

  private dialog = false;
  private valid = false;
  private inquiryServiceDivs: InquiryServiceDivModel[] = [];
  private editedIndex = -1;
  private editedItem: InquiryServiceDivModel = {
    id: 0,
    name: "",
    sort_no: 0,
    is_open: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
    inquiry_groups: [],
  };
  private defaultItem: InquiryServiceDivModel = {
    id: 0,
    name: "",
    sort_no: 0,
    is_open: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
    inquiry_groups: [],
  };

  private headers = [
    { text: "ID", value: "id" },
    { text: "並び順", value: "sort_no" },
    { text: "サービス種類名", value: "name" },
    { text: "最初に開く", value: "is_open" },
    { text: "操作", value: "actions", sortable: false },
  ];

  get formTitle() {
    return this.editedIndex === -1 ? "新規追加" : "編集";
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    val || this.close();
  }

  mounted() {
    this.fetchData();
  }

  private fetchData() {
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiry_master/inquiry_service_div/get",
      {},
      (res) => {
        if (res.data && res.data.inquiry_service_divs) {
          this.inquiryServiceDivs = res.data.inquiry_service_divs;
        }
      }
    );
  }

  private editItem(item: InquiryServiceDivModel) {
    this.editedIndex = this.inquiryServiceDivs.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  private async deleteItem(item: InquiryServiceDivModel) {
    if (await this.$openConfirm("削除しますか？")) {
      this.postJsonCheck(
        window.base_url +
          "/api/admin/inquiry_master/inquiry_service_div/delete",
        { inquiry_service_div: item },
        () => {
          this.fetchData();
        }
      );
    }
  }

  private close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      if (this.form) {
        this.form.resetValidation();
      }
    });
  }

  private save() {
    if (!this.form.validate()) {
      return;
    }

    const url =
      window.base_url + "/api/admin/inquiry_master/inquiry_service_div/save";
    this.postJsonCheck(url, { inquiry_service_div: this.editedItem }, () => {
      this.fetchData();
      this.close();
    });
  }
}
